import { OwnTransportIngredient } from '@apps/main/modules/recipe/ingredients/ownTransportIngredient';
import { OwnTransportTypeQL } from 'libs/trip-planner-interfaces/src/smartSearch/graphql_generated/graphql';

import { IngredientType, TransportType } from '@libs/trip-planner-interfaces';
import type {
  ExposedOwnTransportIngredient,
  OwnTransportType,
} from '@libs/trip-planner-interfaces';

export function createExposedOwnTransportIngredient(
  ownTransportIngredient: OwnTransportIngredient
): ExposedOwnTransportIngredient {
  const ownTransportType = getOwnTransportTypeQL(
    ownTransportIngredient.ownTransportType
  );

  return {
    ingredientType: IngredientType.OwnTransport,
    ownTransportType,
  };
}

export function createOwnTransportIngredient(
  exposedOwnTransportIngredient: ExposedOwnTransportIngredient
): OwnTransportIngredient {
  let ownTransportType: OwnTransportType = TransportType.None;
  if (exposedOwnTransportIngredient.ownTransportType) {
    ownTransportType = getOwnTransportType(
      exposedOwnTransportIngredient.ownTransportType
    );
  }
  const ownTransportIngredient = new OwnTransportIngredient(ownTransportType);

  return ownTransportIngredient;
}

function getOwnTransportTypeQL(
  ownTransportType: OwnTransportType
): OwnTransportTypeQL {
  switch (ownTransportType) {
    case TransportType.Car:
      return OwnTransportTypeQL.Car;
    case TransportType.Bicycle:
      return OwnTransportTypeQL.Cycle;
    case TransportType.Walk:
      return OwnTransportTypeQL.Walk;
    case TransportType.None:
      return OwnTransportTypeQL.Unknown;
    default:
      throw new Error('Unknown transport type');
  }
}

function getOwnTransportType(
  ownTransportTypeQL: OwnTransportTypeQL
): OwnTransportType {
  switch (ownTransportTypeQL) {
    case OwnTransportTypeQL.Car:
      return TransportType.Car;
    case OwnTransportTypeQL.Cycle:
      return TransportType.Bicycle;
    case OwnTransportTypeQL.Walk:
      return TransportType.Walk;
    case OwnTransportTypeQL.Unknown:
      return TransportType.None;
    default:
      throw new Error('Unknown own transport type');
  }
}
